import deepmerge from 'deepmerge';
export const oneOf = function (value, validList) {
    for (let i = 0; i < validList.length; i++) {
        if (validList[i] === value) {
            return true;
        }
    }
    return false;
}
export const setThemeJson = function (list, validList) {
    const skinList = []
    validList.map(item => {
        list.map(items => {
            if (item.theme == items) {
                skinList.push(item)
            }
        })
    })
    return skinList;
}
export const typeOf = function (obj) {
    const toString = Object.prototype.toString;
    const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
    };
    return map[toString.call(obj)];
}
export const deepCopy = function (data) {
    const t = typeOf(data);
    let o;

    if (t === 'array') {
        o = [];
    } else if (t === 'object') {
        o = {};
    } else {
        return data;
    }

    if (t === 'array') {
        for (let i = 0; i < data.length; i++) {
            o.push(deepCopy(data[i]));
        }
    } else if (t === 'object') {
        for (let i in data) {
            o[i] = deepCopy(data[i]);
        }
    }
    return o;
}
//千分位
export const delimiter = function (val) {
    return String(val).replace(/\B(?=(\d{3})+$)/g, ',')
}
export function merge() {
    let arr = Array.prototype.slice.call(arguments);
    return deepmerge.all(arr, {
        arrayMerge: function (destinationArray, sourceArray) {
            return sourceArray || [];
        }
    });
}
// 由一个组件，向上找到最近的指定组件
export function findComponentUpward(context, componentName) {
    let parent = context.$parent;
    let name = parent.$options.name;

    while (parent && (!name || [componentName].indexOf(name) < 0)) {
        parent = parent.$parent;
        if (parent) name = parent.$options.name;
    }
    return parent;
}
// 由一个组件，向下找到最近的指定组件
export function findComponentDownward(context, componentName) {
    const childrens = context.$children;
    let children = null;

    if (childrens.length) {
        for (const child of childrens) {
            const name = child.$options.name;

            if (name === componentName) {
                children = child;
                break;
            } else {
                children = findComponentDownward(child, componentName);
                if (children) break;
            }
        }
    }
    return children;
}